"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var eligibility_1 = require("@bhtp-client-api/eligibility");
var rxjs_1 = require("rxjs");
var base_typeahead_service_1 = require("./base-typeahead-service");
var BhtpStateTypeaheadService = (function (_super) {
    __extends(BhtpStateTypeaheadService, _super);
    function BhtpStateTypeaheadService(bhtpStateService) {
        var _this = _super.call(this) || this;
        _this.bhtpStateService = bhtpStateService;
        return _this;
    }
    BhtpStateTypeaheadService.prototype.search = function (searchValue) {
        var _this = this;
        return rxjs_1.Observable.create(function (observer) {
            if (_this.statesCache && _this.statesCache.length > 0) {
                observer.next(_this.getFilteredResults(searchValue));
                observer.complete();
            }
            else {
                _this.bhtpStateService.getStates().subscribe(function (states) {
                    _this.statesCache = states;
                    observer.next(_this.getFilteredResults(searchValue));
                    observer.complete();
                }, function (error) {
                    observer.error(error);
                });
            }
        });
    };
    ;
    BhtpStateTypeaheadService.prototype.getFilteredResults = function (searchValue) {
        var query = new RegExp(searchValue, 'ig');
        return this.statesCache.filter(function (state) {
            return query.test(state.name);
        });
    };
    return BhtpStateTypeaheadService;
}(base_typeahead_service_1.BhtpBaseTypeaheadService));
BhtpStateTypeaheadService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [eligibility_1.BhtpStateService])
], BhtpStateTypeaheadService);
exports.BhtpStateTypeaheadService = BhtpStateTypeaheadService;
//# sourceMappingURL=D:/a/1/s/typeahead/src/state-typeahead-service.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/typeahead/src/state-typeahead-service.js